export function isOnlyFieldDefined<T extends object>(obj:T, definedField:keyof T) {
    return Object.keys(obj).every(key=>
        key===definedField?obj[key as keyof T] !== undefined : obj[key as keyof T] === undefined);
}

export const isEmptyObject = (obj?: Record<string, unknown> | null): boolean => {
  return (
    obj != null &&
    obj.constructor === Object &&
    Object.keys(obj).length === 0
  );
};
